(function () {
  'use strict';

  // -------------------------------------------------------
  // Cart API のレスポンス処理
  // 422（在庫切れ等）でも JSON は返るため、ok を見ないと失敗を
  // 成功として扱ってしまう。ここで必ず例外に変換する
  // -------------------------------------------------------
  function parseCartResponse(res) {
    return res.json().then(function (data) {
      if (!res.ok) {
        var error = new Error(data.description || data.message || 'Cart API error');
        error.status = res.status;
        error.data = data;
        throw error;
      }
      return data;
    });
  }

  // -------------------------------------------------------
  // GiftWrapping
  // ギフトラッピングUIの制御とCart API操作（複数選択対応）
  // -------------------------------------------------------
  function GiftWrapping() {
    this.wrapper = document.querySelector('[data-gift-variant-ids]');
    if (!this.wrapper) return;

    // ギフト商品のバリアントID一覧（Liquidからdata属性で受け取る）
    var ids = this.wrapper.dataset.giftVariantIds;
    this.giftVariantIds = ids ? ids.split(',') : [];

    this.checkbox   = document.querySelector('[data-gift-checkbox]');
    this.selectWrap = document.getElementById('c_giftSelectWrap');
    this.addButton  = document.querySelector('[data-gift-add]');

    // 備考欄（order_note ブロック）。ラッピングにチェックが入っている間だけ表示する
    this.noteBlock  = document.querySelector('[data-gift-dependent]');
    // 追加済み・未追加をまとめて扱う。チェック状態は「こうしたい状態」を表し、
    // 実際のカート反映は「カートを更新する」ボタンでまとめて行う
    this.options = Array.prototype.slice.call(
      document.querySelectorAll('[data-gift-option]')
    );

    // 上限（カート内のラッピング対象商品の点数合計）
    this.max = parseInt(this.wrapper.dataset.giftMax, 10) || 0;

    // 処理中にロックする対象（チェックアウト / 状態表示）
    this.form           = this.wrapper.closest('form');
    this.checkoutButton = this.form ? this.form.querySelector('button[name="checkout"]') : null;
    this.statusEl       = this.wrapper.querySelector('[data-gift-status]');

    // is_gift_only 等で元から無効なボタンを処理完了後に誤って有効化しないため記憶
    this.checkoutInitiallyDisabled = this.checkoutButton ? this.checkoutButton.disabled : false;

    // -------------------------------------------------------
    // 現在のカートでは成立しないギフト明細の自動クリーンアップ
    // Liquidが算出した「あるべき数量」へ一括で補正する
    // （ラッピング不可商品の追加 / BOX不可 / 上限超過）
    // -------------------------------------------------------
    if (this.wrapper.dataset.giftCleanupUpdates) {
      this._runCleanup(this.wrapper.dataset.giftCleanupUpdates);
      return;
    }

    // -------------------------------------------------------
    // 属性 'yes' のままカート内にギフト商品が無い（明細削除等）
    // → 属性のみ静かに 'no' へリセット（リロード不要）
    // -------------------------------------------------------
    if (this.wrapper.dataset.giftAttrReset === 'true') {
      this._updateCartAttribute('no').catch(function (error) {
        console.error('[c_cart-gift-wrapping]', 'attribute reset failed', error);
      });
    }

    if (!this.checkbox || !this.selectWrap) return;

    this._bindEvents();
  }

  // -------------------------------------------------------
  // クリーンアップ実行
  // updatesJson: {"<variant_id>": <目標数量>, ...}
  // -------------------------------------------------------
  GiftWrapping.prototype._runCleanup = function (updatesJson) {
    var self = this;
    var updates;

    try {
      updates = JSON.parse(updatesJson);
    } catch (error) {
      console.error('[c_cart-gift-wrapping]', 'cleanup payload parse failed', error);
      return;
    }

    // 補正後にギフトが1つも残らないなら属性も 'no' へ戻す
    var willBeEmpty = Object.keys(updates).every(function (key) {
      return updates[key] === 0;
    });

    this._setBusy('removing');

    var chain = willBeEmpty ? this._updateCartAttribute('no') : Promise.resolve();

    chain
      .then(function () { return self._applyUpdates(updates); })
      .then(function () { self._reloadCart(); })
      .catch(function (error) {
        console.error('[c_cart-gift-wrapping]', 'cleanup failed', error);
        self._clearBusy();
      });
  };

  // -------------------------------------------------------
  // イベント登録
  // -------------------------------------------------------
  GiftWrapping.prototype._bindEvents = function () {
    var self = this;

    // チェックON → 選択エリア表示
    // チェックOFF → 非表示 + ギフト商品があれば全削除してリロード
    this.checkbox.addEventListener('change', function () {
      if (this.checked) {
        self.selectWrap.style.display = '';
        self._setNoteVisible(true);
        self._updateCartAttribute('yes').catch(function (error) {
          console.error('[c_cart-gift-wrapping]', 'attribute update failed', error);
        });
      } else {
        self.selectWrap.style.display = 'none';
        self._setNoteVisible(false);
        self._setBusy('removing');
        self._updateCartAttribute('no')
          .then(function () { return self._removeAllGiftItems(); })
          .then(function (hadGiftItems) {
            if (hadGiftItems) {
              self._reloadCart(); // リロード中は busy のまま遷移
            } else {
              self._clearBusy(); // 削除対象なし → ロック解除
            }
          })
          .catch(function (error) {
            console.error('[c_cart-gift-wrapping]', 'remove gift failed', error);
            self._clearBusy();
          });
      }
    });

    // チェックの付け外しはカート未反映。ここでは表示と上限だけ更新する
    this.options.forEach(function (option) {
      var check = option.querySelector('[data-gift-option-check]');
      if (!check) return;

      // ブラウザのフォーム状態復元に負けないよう、カートの実態を明示的に反映する
      check.checked = option.hasAttribute('data-gift-option-added');

      check.addEventListener('change', function () { self._refreshPicker(); });
    });

    // 「カートを更新する」→ 追加と削除を1回のリロードでまとめて反映
    if (this.addButton) {
      this.addButton.addEventListener('click', function () {
        var diff = self._pickerDiff();
        if (!diff.items.length && !diff.hasRemovals) return;

        self._setBusy(diff.items.length ? 'adding' : 'removing');

        // 先に削除して枠を空けてから追加する
        var chain = diff.hasRemovals
          ? self._applyUpdates(diff.updates)
          : Promise.resolve();

        chain
          .then(function () {
            return diff.items.length ? self._addGiftItems(diff.items) : null;
          })
          .then(function () { return fetch('/cart.js').then(parseCartResponse); })
          .then(function (cart) { return self._syncAttribute(cart); })
          .then(function () { self._reloadCart(); })
          .catch(function (error) {
            console.error('[c_cart-gift-wrapping]', 'update gift failed', error);
            self._clearBusy();
          });
      });
    }

    // 選択済み一覧の数量変更 / 削除（明細行に委譲）
    this.selectWrap.addEventListener('click', function (event) {
      var qtyButton = event.target.closest('[data-gift-qty]');
      var removeButton = event.target.closest('[data-gift-remove]');
      if (!qtyButton && !removeButton) return;

      var line = event.target.closest('[data-gift-line]');
      if (!line) return;

      var key = line.dataset.giftLineKey;
      var quantity = removeButton ? 0 : parseInt(qtyButton.dataset.giftQty, 10);
      if (isNaN(quantity) || quantity < 0) return;

      self._setBusy(quantity === 0 ? 'removing' : 'adding');
      self._changeLine(key, quantity)
        .then(function (cart) { return self._syncAttribute(cart); })
        .then(function () { self._reloadCart(); })
        .catch(function (error) {
          console.error('[c_cart-gift-wrapping]', 'update gift line failed', error);
          self._clearBusy();
        });
    });

    // 初期表示（上限到達時の + 無効化など）を反映
    this._refreshPicker();
  };

  // -------------------------------------------------------
  // 備考欄の表示切替
  // 入力済みの内容は消さない（チェックし直せばそのまま戻る）
  // -------------------------------------------------------
  GiftWrapping.prototype._setNoteVisible = function (visible) {
    if (!this.noteBlock) return;
    this.noteBlock.hidden = !visible;
  };

  // -------------------------------------------------------
  // ピッカー1行が選択されているか
  // -------------------------------------------------------
  GiftWrapping.prototype._isChecked = function (option) {
    var check = option.querySelector('[data-gift-option-check]');
    return !!(check && check.checked);
  };

  // -------------------------------------------------------
  // 1行が占める点数
  // 追加済みはカート内の数量、未追加は1点として数える
  // -------------------------------------------------------
  GiftWrapping.prototype._optionQuantity = function (option) {
    return parseInt(option.dataset.giftOptionQuantity, 10) || 1;
  };

  // -------------------------------------------------------
  // チェックされている行の合計点数（カート未反映の希望状態）
  // 追加済みのチェックを外すとその分だけ枠が空く
  // -------------------------------------------------------
  GiftWrapping.prototype._pickerTotal = function () {
    var self = this;
    return this.options.reduce(function (sum, option) {
      return sum + (self._isChecked(option) ? self._optionQuantity(option) : 0);
    }, 0);
  };

  // -------------------------------------------------------
  // カートの現状とチェック状態の差分
  // items   … 新たに追加する行（/cart/add.js 用）
  // updates … 取り消す行（variant_id => 0）
  // -------------------------------------------------------
  GiftWrapping.prototype._pickerDiff = function () {
    var self = this;
    var items = [];
    var updates = {};
    var hasRemovals = false;

    this.options.forEach(function (option) {
      var isAdded = option.hasAttribute('data-gift-option-added');
      var checked = self._isChecked(option);

      if (checked && !isAdded) {
        items.push({ id: parseInt(option.dataset.giftOptionId, 10), quantity: 1 });
      } else if (!checked && isAdded) {
        updates[option.dataset.giftOptionId] = 0;
        hasRemovals = true;
      }
    });

    return { items: items, updates: updates, hasRemovals: hasRemovals };
  };

  // -------------------------------------------------------
  // ピッカーの表示更新
  // 上限に達したら未選択の行を選べなくし、ボタンに差分の内容を出す
  // -------------------------------------------------------
  GiftWrapping.prototype._refreshPicker = function () {
    var total = this._pickerTotal();
    var canAddMore = total < this.max;

    this.options.forEach(function (option) {
      var check = option.querySelector('[data-gift-option-check]');
      if (!check) return;

      // チェック済みの行は外せるよう有効のままにする
      check.disabled = !canAddMore && !check.checked;
      option.classList.toggle('is-selected', check.checked);
      option.classList.toggle('is-disabled', check.disabled);

      // 追加済みなのに外されている＝更新で削除される行
      option.classList.toggle(
        'is-pending-remove',
        option.hasAttribute('data-gift-option-added') && !check.checked
      );
    });

    if (this.addButton) {
      var diff = this._pickerDiff();
      var data = this.addButton.dataset;

      if (!diff.items.length && !diff.hasRemovals) {
        this.addButton.disabled = true;
        this.addButton.textContent = data.labelIdle;
      } else if (diff.hasRemovals) {
        this.addButton.disabled = false;
        this.addButton.textContent = data.labelUpdate;
      } else {
        this.addButton.disabled = false;
        this.addButton.textContent = data.labelCount.replace('__n__', diff.items.length);
      }
    }
  };

  // -------------------------------------------------------
  // 処理中ロック: チェックアウト/高速決済を無効化し状態を表示
  // mode: 'adding' | 'removing'
  // -------------------------------------------------------
  GiftWrapping.prototype._setBusy = function (mode) {
    if (this.form) this.form.classList.add('c_is-gift-processing');

    if (this.checkoutButton) {
      this.checkoutButton.disabled = true;
      this.checkoutButton.setAttribute('aria-disabled', 'true');
    }

    if (this.statusEl) {
      var label = mode === 'removing' ? this.statusEl.dataset.labelRemoving : this.statusEl.dataset.labelAdding;
      this.statusEl.textContent = label || '';
      this.statusEl.hidden = false;
    }
  };

  // -------------------------------------------------------
  // 処理中ロックの解除
  // -------------------------------------------------------
  GiftWrapping.prototype._clearBusy = function () {
    if (this.form) this.form.classList.remove('c_is-gift-processing');

    if (this.checkoutButton) {
      this.checkoutButton.disabled = this.checkoutInitiallyDisabled;
      if (this.checkoutInitiallyDisabled) {
        this.checkoutButton.setAttribute('aria-disabled', 'true');
      } else {
        this.checkoutButton.removeAttribute('aria-disabled');
      }
    }

    if (this.statusEl) {
      this.statusEl.hidden = true;
      this.statusEl.textContent = '';
    }
  };

  // -------------------------------------------------------
  // Cart attribute 更新 / value: 'yes' | 'no'
  // -------------------------------------------------------
  GiftWrapping.prototype._updateCartAttribute = function (value) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'gift_wrapping': value } })
    }).then(parseCartResponse);
  };

  // -------------------------------------------------------
  // カート内容から属性を同期
  // ギフトが1つも残っていなければ 'no' へ戻す
  // -------------------------------------------------------
  GiftWrapping.prototype._syncAttribute = function (cart) {
    var self = this;

    var hasGift = cart.items.some(function (item) {
      return self.giftVariantIds.indexOf(String(item.variant_id)) !== -1;
    });

    return this._updateCartAttribute(hasGift ? 'yes' : 'no');
  };

  // -------------------------------------------------------
  // updates（variant_id => 数量）をカートへ適用
  // -------------------------------------------------------
  GiftWrapping.prototype._applyUpdates = function (updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).then(parseCartResponse);
  };

  // -------------------------------------------------------
  // 明細1行の数量変更 / quantity 0 で削除
  // -------------------------------------------------------
  GiftWrapping.prototype._changeLine = function (key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(parseCartResponse);
  };

  // -------------------------------------------------------
  // カート内のギフト商品をすべて削除
  // ギフト商品があった場合: true / なかった場合: false
  // -------------------------------------------------------
  GiftWrapping.prototype._removeAllGiftItems = function () {
    var self = this;

    return fetch('/cart.js')
      .then(parseCartResponse)
      .then(function (cart) {
        var updates = {};
        var hasGift = false;

        cart.items.forEach(function (item) {
          if (self.giftVariantIds.indexOf(String(item.variant_id)) !== -1) {
            updates[item.variant_id] = 0;
            hasGift = true;
          }
        });

        if (!hasGift) return false; // ギフトなし

        return self._applyUpdates(updates).then(function () { return true; });
      });
  };

  // -------------------------------------------------------
  // ギフト商品をまとめてカートに追加
  // items: [{ id: <variant_id>, quantity: <n> }, ...]
  // -------------------------------------------------------
  GiftWrapping.prototype._addGiftItems = function (items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(parseCartResponse);
  };

  // -------------------------------------------------------
  // カートページをリロード（ページ型カート用）
  // -------------------------------------------------------
  GiftWrapping.prototype._reloadCart = function () {
    window.location.reload();
  };

  // -------------------------------------------------------
  // 初期化
  // -------------------------------------------------------
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { new GiftWrapping(); });
  } else {
    new GiftWrapping();
  }

})();
